import { render } from "./LoadingScreen.vue?vue&type=template&id=4cff4ee6&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=4cff4ee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cff4ee6"]])

export default __exports__